export class ErrorHandler {
  static extractErrorMessage(error: any): string {
    // Check for the new API error structure
    if (error?.error?.errors) {
      // Get the first error message from the errors object
      const firstErrorKey = Object.keys(error.error.errors)[0];
      if (firstErrorKey) {
        return error.error.errors[firstErrorKey];
      }
    }

    // Check for message field
    if (error?.error?.message) {
      return error.error.message;
    }

    // Check for detail field (old structure)
    if (error?.error?.detail) {
      return error.error.detail;
    }

    // Check for direct message on error
    if (error?.message) {
      return error.message;
    }

    // Default error message
    return 'An unexpected error occurred. Please try again.';
  }

  static extractAllErrors(error: any): string[] {
    const errors: string[] = [];

    // Check for the new API error structure with multiple errors
    if (error?.error?.errors && typeof error.error.errors === 'object') {
      Object.values(error.error.errors).forEach((msg) => {
        if (typeof msg === 'string') {
          errors.push(msg);
        }
      });
    }

    // If no errors found, try to get a single error message
    if (errors.length === 0) {
      errors.push(this.extractErrorMessage(error));
    }

    return errors;
  }
}
